// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1p_4V","emails":"CreateEditClinics_emails__3AICU","emailTagLabel":"CreateEditClinics_emailTagLabel__r9mYI"};